import { TREATMENT_TYPES } from "@app/constants";

export const CREATE_SESSION_MODES = {
  CREATE: 1,
  EDIT: 2,
  DUPLICATE: 3,
};

export const PARTICIPANTS_LIMIT = {
  [TREATMENT_TYPES.THERAPY.id]: 5,
  [TREATMENT_TYPES.GROUP.id]: 5,
  [TREATMENT_TYPES.CLASS.id]: 20,
  [TREATMENT_TYPES.V4_SESSION_PILOT.id]: 20,
};

export const TIMEZONE_OPTIONS = {
  THERAPIST: 1,
  ADMIN: 2,
};

export const recUpdateTypes = {
  CURRENT: "current",
  FOLLOWING: "following",
  //ALL: "all",
};

export const defaultSpeechTherapySessionDuration = 45;
export const defaultDyslexiaSessionDuration = 45;
